var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1906 15.5923C28.5938 14.3434 27.2178 13.6818 25.8797 14.3204C24.5416 14.959 23.9715 16.4734 24.5317 17.8028C25.092 19.1323 27.343 22.4879 27.343 22.4879C27.343 22.4879 30.9702 20.7073 32.1201 19.8361C33.27 18.9649 33.5548 17.3636 32.6939 16.1462C31.833 14.9289 30.3319 14.8091 29.1906 15.5923Z",
    fill: "#0C5D53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32.087H20.6103C20.9506 32.087 21.2889 32.1275 21.6188 32.2085L24.3769 32.8788C24.9753 33.0246 25.5988 33.0387 26.2035 32.9213L29.253 32.328C30.0585 32.1711 30.7996 31.7853 31.3803 31.2204L33.5379 29.1216C34.154 28.5233 34.154 27.5523 33.5379 26.953C32.9832 26.4133 32.1047 26.3526 31.4771 26.8102L28.9626 28.6447C28.6025 28.908 28.1643 29.0497 27.7137 29.0497H25.2855L26.8311 29.0497C27.7022 29.0497 28.4079 28.3632 28.4079 27.5158V27.209C28.4079 26.5054 27.9156 25.8919 27.2141 25.7218L24.8286 25.1416C24.4404 25.0475 24.0428 24.9999 23.6431 24.9999C22.6783 24.9999 20.9319 25.7987 20.9319 25.7987L18 27.0248M14 26.5999L14 32.3999C14 32.9599 14 33.24 14.109 33.4539C14.2049 33.642 14.3578 33.795 14.546 33.8909C14.7599 33.9999 15.0399 33.9999 15.6 33.9999H16.4C16.9601 33.9999 17.2401 33.9999 17.454 33.8909C17.6422 33.795 17.7951 33.642 17.891 33.4539C18 33.24 18 32.9599 18 32.3999V26.5999C18 26.0398 18 25.7598 17.891 25.5459C17.7951 25.3577 17.6422 25.2048 17.454 25.1089C17.2401 24.9999 16.9601 24.9999 16.4 24.9999H15.6C15.0399 24.9999 14.7599 24.9999 14.546 25.1089C14.3578 25.2048 14.2049 25.3577 14.109 25.5459C14 25.7598 14 26.0398 14 26.5999ZM29.1914 15.5921C28.5946 14.3433 27.2186 13.6817 25.8804 14.3203C24.5423 14.9589 23.9722 16.4733 24.5325 17.8027C24.8787 18.6244 25.8707 20.2199 26.5781 21.3189C26.8394 21.725 26.9701 21.928 27.161 22.0468C27.3247 22.1487 27.5297 22.2036 27.7224 22.1972C27.9471 22.1898 28.1618 22.0793 28.5911 21.8583C29.7532 21.2602 31.4101 20.3744 32.1208 19.836C33.2707 18.9648 33.5556 17.3635 32.6947 16.1461C31.8337 14.9288 30.3327 14.809 29.1914 15.5921Z",
    stroke: "#0C5D53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.61d73704199f8afc408b263d19fc5ca1.svg";
export { ForwardRef as ReactComponent };